import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const FlexContainer = ({ children }) => <Wrapper>{children}</Wrapper>;

export default FlexContainer;
